import { render, staticRenderFns } from "./detail_site.vue?vue&type=template&id=4d05618f&scoped=true&"
import script from "./detail_site.vue?vue&type=script&lang=js&"
export * from "./detail_site.vue?vue&type=script&lang=js&"
import style0 from "./detail_site.vue?vue&type=style&index=0&id=4d05618f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05618f",
  null
  
)

export default component.exports